import { useEffect } from "react";
import { Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { initLenis, destroyLenis } from "@/lib/scroll";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#FAF8F5] px-6">
          <div className="max-w-md text-center">
            <p className="font-serif text-3xl text-[#1A1816]">Something went wrong.</p>
            <p className="mt-3 text-sm text-[#6E6A63]">Please refresh the page — our team has been notified.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </ErrorBoundary>
      <Toaster position="top-center" richColors toastOptions={{ style: { borderRadius: 0 } }} />
    </BrowserRouter>
  );
}

export default App;
